var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 110H88.3334C91.0947 110 93.3334 107.761 93.3334 105V48.3333C93.3334 45.572 91.0947 43.3333 88.3334 43.3333H83.3334V28.3333C83.3334 12.7103 70.6231 0 55.0001 0C39.3771 0 26.6667 12.7103 26.6667 28.3333V43.3333H21.6667C18.9054 43.3333 16.6667 45.572 16.6667 48.3333V105C16.6667 107.761 18.9054 110 21.6667 110ZM60.0001 78.3287V85C60.0001 87.7613 57.7614 90 55.0001 90C52.2387 90 50.0001 87.7613 50.0001 85V78.3287C47.9774 76.807 46.6667 74.3873 46.6667 71.6667C46.6667 67.0717 50.4051 63.3333 55.0001 63.3333C59.5951 63.3333 63.3334 67.0717 63.3334 71.6667C63.3334 74.3873 62.0227 76.807 60.0001 78.3287ZM36.6667 28.3333C36.6667 18.2243 44.8911 10 55.0001 10C65.1091 10 73.3334 18.2243 73.3334 28.3333V43.3333H36.6667V28.3333Z",
    fill: "#80E614"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.3de46f8115412236fa6e63774a5da0b9.svg";
export { ForwardRef as ReactComponent };